import {request} from '../../request'

export const loginUser = (data)=>{
    return request.post("auth/login",data)
}